import { Button, Image, makeStyles, mergeClasses, Text } from "@fluentui/react-components";
import { Checkmark24Regular } from "@fluentui/react-icons";
import IPageImage from "../../../models/page/pageComponents/IPageImage";
import { dolphinTokens } from "../../../utils/Theme";
import TitleText from "../../../components/titleText/TitleText";

const useStyles = makeStyles({
    mainContainer: {
        padding: '2rem',
        display: 'flex',
        flexWrap: 'wrap',
    },
    textContent: {
        padding: '20px',
    },
    ctaBtnPrimary: {
        marginTop: '20px',
    },
    imageColumn: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flex: '1 1 50%',

        "@media (max-width: 600px)": {
            order: -1,
            flex: '1 1 100%',
        },
    },
    textColumn: {
        flex: '1 1 50%',

        "@media (max-width: 600px)": {
            flex: '1 1 100%',
        },
    },
    image: {
        width: '100%',
        height: 'auto',
    },
    imageLeft: {
        order: 0,
    },
    imageRight: {
        order: 1,
    },
    textLeft: {
        order: 0,
    },
    textRight: {
        order: 1,
    },
    tiltLeft: {
        width: "90%",
        transform: "rotateY(30deg) rotateX(20deg)"
    },
    tiltRight: {
        width: "90%",
        transform: "rotateY(-30deg) rotateX(20deg)"
    },
    pointList: {
        listStyleType: "none",
        padding: 0,
    },
    pointItem: {
        marginBottom: "1rem",

        "& h3": {
            marginTop: "2rem",
            color: dolphinTokens.colorLightBlue
        },

        "& h5": {
            marginTop: ".5rem",
            marginLeft: "2rem",
            color: "#869ab8",
        },
    },
    checkIcon: {
        marginRight: "0.5rem",
        marginBottom: "-0.25rem",
        color: dolphinTokens.colorLightBlue,
    },
});



export default function ServiceImage(props: IPageImage) {
    const styles = useStyles();

    const handleButtonClick = () => window.location.href = props.buttonLink!;

    const imagePosition = props.image.position === 'left'
        ? styles.imageLeft
        : styles.imageRight;

    const textPosition = props.image.position === 'left'
        ? styles.textRight
        : styles.textLeft;
    
    const imageColumnClass = mergeClasses(styles.imageColumn, imagePosition),
        textColumnClass = mergeClasses(styles.textColumn, textPosition),
        imageClass = !props.image.tilt
            ? styles.image
            : mergeClasses(styles.image, props.image.position === "left" ? styles.tiltLeft : styles.tiltRight);

    return (
        <div className={styles.mainContainer}>
            <div className={imageColumnClass}>
                <Image
                    src={props.image.url}
                    alt={props.image.altText}
                    className={imageClass}
                />
            </div>
            <div className={textColumnClass}>
                <div className={styles.textContent}>
                    <TitleText
                        title={props.title}
                        titleHighlightedWords={props.titleHighlightedWords}
                        alignment={"start"}
                        width="100%"
                        marginBottom="0"
                        padding="0"
                        titleMargin="0"
                        />
                        
                    {
                        props.descriptions &&
                        props.descriptions?.map((description, index) => (
                            <Text block key={index} as="h4" size={400}>
                                {description}
                            </Text>
                        ))
                    }
                    {
                        props.details &&
                        <ul className={styles.pointList}>
                            {
                                props.details.map((detail, index) => (
                                    <li key={index} className={styles.pointItem}>
                                        <div>
                                            <Checkmark24Regular className={styles.checkIcon} />
                                            <Text as="h3" size={500}>
                                                {detail.title}
                                            </Text>
                                            <Text block as="h5" size={400}>
                                                {detail.description}
                                            </Text>
                                        </div>
                                    </li>
                                ))
                            }
                        </ul>
                    }
                    {
                        props.buttonText && props.buttonLink &&
                        <Button appearance="primary" onClick={handleButtonClick} className={styles.ctaBtnPrimary}>
                            {props.buttonText}
                        </Button>
                    }
                </div>
            </div>
        </div>
    );
}